import BaseService from '@/services/BaseService';

class TourDashboardService extends BaseService {
    getTourCount = () => this.get('/agency/dashboardTours');

    getAccommodationCount = () => this.get('/agency/dashboardAccommodation');
}

export default new TourDashboardService();
